<div class="h-100" *ngIf="!isLoading; else loading">
  <ng-container [ngSwitch]="panel">
    <table class="w-100" *ngSwitchCase="'keyfields'">
      <tbody>
        <tr>
          <td>Input File Name</td>
          <td>{{ claim.inputFilename || '' }}</td>
        </tr>
        <tr>
          <td>Report MailBox ID</td>
          <td>{{ claim.reportId || '' }}</td>
        </tr>
        <tr>
          <td>SC Provider ID</td>
          <td>{{ claim.providerId || '' }}</td>
        </tr>
        <tr>
          <td>SC EDI ID</td>
          <td>{{ claim.neicId || '' }}</td>
        </tr>
        <tr>
          <td>SC Processor ID</td>
          <td>{{ claim.processorId || '' }}</td>
        </tr>
        <tr>
          <td>Patient name</td>
          <td>{{ claim.patientName || '' }}</td>
        </tr>
        <tr>
          <td>Insured Name</td>
          <td>{{ claim.insuredName || '' }}</td>
        </tr>
        <tr>
          <td>Date Of Service</td>
          <td>{{ claim.firstServiceDate || '' }}</td>
        </tr>
        <tr>
          <td>Total Charges</td>
          <td>{{ claim.totalCharges || '' }}</td>
        </tr>
        <tr>
          <td>Patient Acct #</td>
          <td>{{ claim.patientAccountNumber || '' }}</td>
        </tr>
        <tr>
          <td>Status Flag</td>
          <td>{{ claim.statusFlag || '' }}</td>
        </tr>
        <tr>
          <td>Batch Status</td>
          <td>{{ claim.batchStatus || '' }}</td>
        </tr>
        <tr>
          <td>Report File Name</td>
          <td>{{ claim.reportFilename || '' }}</td>
        </tr>
        <tr>
          <td>Transmit File Name</td>
          <td>{{ claim.transmitFilename || '' }}</td>
        </tr>
        <tr>
          <td>Input Claim Format</td>
          <td>{{ claim.inputFormat || '' }}</td>
        </tr>
        <tr>
          <td>Claim ID</td>
          <td>{{ claim.claimId || '' }}</td>
        </tr>
        <tr>
          <td>Process Date</td>
          <td>{{ claim.carrierProcessDate || '' }}</td>
        </tr>
        <tr>
          <td>Process Time</td>
          <td>{{ claim.carrierProcessTime || '' }}</td>
        </tr>
        <tr>
          <td>Current Status</td>
          <td>{{ claim.claimStatus || '' }}</td>
        </tr>
        <tr>
          <td>Billing Name</td>
          <td>
            {{
              claim.billingProviderFirstname +
                ' ' +
                claim.billingProviderLastname || ''
            }}
          </td>
        </tr>
        <tr>
          <td>Billing NPI</td>
          <td>{{ claim.billingNpi || '' }}</td>
        </tr>
        <tr>
          <td>Billing TaxId</td>
          <td>{{ claim.billingTaxId || '' }}</td>
        </tr>
        <tr>
          <td>Rendering NPI</td>
          <td>{{ claim.renderingNpi || '' }}</td>
        </tr>
        <tr>
          <td>Provider Name</td>
          <td>
            {{ claim.providerFirstname + ' ' + claim.providerLastname || '' }}
          </td>
        </tr>
        <tr>
          <td>Payer Responsibility</td>
          <td>{{ claim.payerResponibility || '' }}</td>
        </tr>
        <tr>
          <td>XML Filename</td>
          <td>{{ claim.xmlFilename || '' }}</td>
        </tr>
        <tr>
          <td>File name 277CA</td>
          <td>{{ claim.filename277ca || '' }}</td>
        </tr>
        <tr>
          <td>CSV File Name</td>
          <td>{{ claim.csvFilename || '' }}</td>
        </tr>
      </tbody>
    </table>

    <ng-container *ngSwitchCase="'statusDetails'">
      <div class="card bg-transparent mb-3" *ngFor="let message of response">
        <table class="w-100 mb-3">
          <tbody>
            <tr>
              <td>Message From</td>
              <td>{{ message.messageFrom || 'N/A' }}</td>
            </tr>
            <tr>
              <td>Message Date</td>
              <td>{{ (message.messageDate | date: 'MM/dd/yy') || 'N/A' }}</td>
            </tr>
            <tr>
              <td>Status</td>
              <td>{{ message.status || 'N/A' }}</td>
            </tr>
            <tr>
              <td>Data Error</td>
              <td>{{ message.dataError || 'N/A' }}</td>
            </tr>
            <tr>
              <td>Message</td>
              <td>{{ message.message || 'N/A' }}</td>
            </tr>
            <tr>
              <td>Service Info</td>
              <td>{{ message.serviceInfo || 'N/A' }}</td>
            </tr>
            <tr>
              <td>Status Bucket</td>
              <td>{{ message.statusBucket || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <div *ngSwitchCase="'inputClaim'" class="text-break h-100">
      <ng-container *ngIf="response && response?.length; else error">
        {{ response }}
      </ng-container>
    </div>

    <div
      *ngSwitchCase="'outputClaim'"
      class="h-100"
      [class.pre-panel]="response && response?.length"
    >
      <ng-container *ngIf="response && response?.length; else error">
        {{ response }}
      </ng-container>
    </div>

    <div *ngSwitchCase="'errors'" class="h-100">
      <ng-container *ngIf="response && response?.length; else error">
        <div class="card bg-transparent mb-3" *ngFor="let error of response">
          <table class="w-100 mb-3">
            <tbody>
              <tr>
                <td>Provider Id</td>
                <td>{{ error.providerId || 'N/A' }}</td>
              </tr>
              <tr>
                <td>Claim Id</td>
                <td>{{ error.claimId || 'N/A' }}</td>
              </tr>
              <tr>
                <td>Error Id</td>
                <td>{{ error.errorId || 'N/A' }}</td>
              </tr>
              <tr>
                <td>Id</td>
                <td>{{ error.id || 'N/A' }}</td>
              </tr>
              <tr>
                <td>Error Date</td>
                <td>{{ (error.errorDate | date: 'MM/dd/yy') || 'N/A' }}</td>
              </tr>
              <tr>
                <td>lxCounter</td>
                <td>{{ error.lxCounter || 'N/A' }}</td>
              </tr>
              <tr>
                <td>Message Info</td>
                <td>{{ error.messageInfo || 'N/A' }}</td>
              </tr>
              <tr>
                <td>Message Text</td>
                <td>{{ error.messageText || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>

    <div *ngSwitchCase="'transmit'" class="text-break h-100">
      <ng-container
        *ngIf="response && response?.claimDownloadResponse; else error"
      >
        <div class="fw-demi-bold mb-2">
          {{ response.claimDownloadResponse.filename }}
        </div>
        {{ response.claimDownloadResponse.data }}
      </ng-container>
    </div>

    <!-- review -->
    <div *ngSwitchCase="'inputFile'" class="text-break h-100">
      <ng-container
        *ngIf="response && response?.claimDownloadResponse; else error"
      >
        <div class="fw-demi-bold mb-2">
          {{ response.claimDownloadResponse.filename }}
        </div>
        {{ response.claimDownloadResponse.data }}
      </ng-container>
    </div>

    <div *ngSwitchCase="'remittance'" class="text-break h-100">
      <ng-container *ngIf="response && response?.length; else error">
        <div
          class="card bg-transparent mb-3"
          *ngFor="let remittance of response"
        >
          <table class="w-100 mb-3">
            <tbody>
              <tr>
                <td width="50%">Id</td>
                <td width="50%">{{ remittance.id || 'N/A' }}</td>
              </tr>
              <tr>
                <td>npiOrTaxId</td>
                <td>{{ remittance.npiOrTaxId || 'N/A' }}</td>
              </tr>
              <tr>
                <td>exportDate</td>
                <td>{{ remittance.exportDate || 'N/A' }}</td>
              </tr>
              <tr>
                <td>creationDate</td>
                <td>{{ remittance.creationDate || 'N/A' }}</td>
              </tr>
              <tr>
                <td>dateOfService</td>
                <td>{{ remittance.dateOfService || 'N/A' }}</td>
              </tr>
              <tr>
                <td>processFlag</td>
                <td>{{ remittance.processFlag || 'N/A' }}</td>
              </tr>
              <tr>
                <td>inputData</td>
                <td>{{ remittance.inputData || 'N/A' }}</td>
              </tr>
              <tr>
                <td>checkNumber</td>
                <td>{{ remittance.checkNumber || 'N/A' }}</td>
              </tr>
              <tr>
                <td>apicategory</td>
                <td>{{ remittance.apicategory || 'N/A' }}</td>
              </tr>
              <tr>
                <td>description</td>
                <td>{{ remittance.description || 'N/A' }}</td>
              </tr>

              <tr>
                <td>Carrier Details</td>
                <td class="expand-cell">
                  <div class="d-flex align-items-center justify-content-end">
                    <a
                      href="javascript:void(0)"
                      class="standart-link-action"
                      (click)="
                        remittance.isCarrierExpanded =
                          !remittance.isCarrierExpanded
                      "
                      [class.expanded]="remittance.isCarrierExpanded"
                      [attr.aria-expanded]="!remittance.isCarrierExpanded"
                    >
                      <i class="fas fa-chevron-down"></i>
                    </a>
                  </div>
                </td>
              </tr>

              <tr
                class="claim-remit-inner"
                *ngIf="remittance.isCarrierExpanded"
              >
                <td>Carrier</td>
                <td>{{ remittance.carrier || 'N/A' }}</td>
              </tr>
              <tr>
                <td>Carrier Process Date</td>
                <td>
                  {{
                    (remittance.carrierProcessDate | date: 'MM/dd/yy') || 'N/A'
                  }}
                </td>
              </tr>
              <tr>
                <td>carrierProcessTime</td>
                <td>{{ remittance.carrierProcessTime || 'N/A' }}</td>
              </tr>
              <tr>
                <td>carrierTraceNumber</td>
                <td>{{ remittance.carrierTraceNumber || 'N/A' }}</td>
              </tr>

              <tr>
                <td>Payer Details</td>
                <td class="expand-cell">
                  <div class="d-flex align-items-center justify-content-end">
                    <a
                      href="javascript: void(0)"
                      class="standart-link-action"
                      (click)="
                        remittance.isPayerExpanded = !remittance.isPayerExpanded
                      "
                      [class.expanded]="remittance.isPayerExpanded"
                      [attr.aria-expanded]="!remittance.isPayerExpanded"
                    >
                      <i class="fas fa-chevron-down"></i>
                    </a>
                  </div>
                </td>
              </tr>

              <tr class="claim-remit-inner" *ngIf="remittance.isPayerExpanded">
                <td>payerTraceNumber</td>
                <td>{{ remittance.payerTraceNumber || 'N/A' }}</td>
              </tr>
              <tr>
                <td>payerId</td>
                <td>{{ remittance.payerId || 'N/A' }}</td>
              </tr>
              <tr>
                <td>payerName</td>
                <td>{{ remittance.payerName || 'N/A' }}</td>
              </tr>

              <tr>
                <td>Claim Details</td>
                <td class="expand-cell">
                  <div class="d-flex align-items-center justify-content-end">
                    <a
                      href="javascript: void(0)"
                      class="standart-link-action"
                      (click)="
                        remittance.isClaimExpanded = !remittance.isClaimExpanded
                      "
                      [class.expanded]="remittance.isClaimExpanded"
                      [attr.aria-expanded]="!remittance.isClaimExpanded"
                    >
                      <i class="fas fa-chevron-down"></i>
                    </a>
                  </div>
                </td>
              </tr>

              <tr class="claim-remit-inner" *ngIf="remittance.isClaimExpanded">
                <td>claimId</td>
                <td>{{ remittance.claimId || 'N/A' }}</td>
              </tr>
              <tr>
                <td>claimCharges</td>
                <td>{{ remittance.claimCharges || 'N/A' }}</td>
              </tr>
              <tr>
                <td>claimPaidAmount</td>
                <td>{{ remittance.claimPaidAmount || 'N/A' }}</td>
              </tr>
              <tr>
                <td>claimStatus</td>
                <td>{{ remittance.claimStatus || 'N/A' }}</td>
              </tr>

              <tr>
                <td>Patient Details</td>
                <td class="expand-cell">
                  <div class="d-flex align-items-center justify-content-end">
                    <a
                      href="javascript: void(0)"
                      class="standart-link-action"
                      (click)="
                        remittance.isPatientExpanded =
                          !remittance.isPatientExpanded
                      "
                      [class.expanded]="remittance.isPatientExpanded"
                      [attr.aria-expanded]="!remittance.isPatientExpanded"
                    >
                      <i class="fas fa-chevron-down"></i>
                    </a>
                  </div>
                </td>
              </tr>

              <tr [(ngbCollapse)]="remittance.isPatientExpanded">
                <td>patientAccountNumber</td>
                <td>{{ remittance.patientAccountNumber || 'N/A' }}</td>
              </tr>
              <tr>
                <td>patientName</td>
                <td>{{ remittance.patientName || 'N/A' }}</td>
              </tr>

              <tr>
                <td>Provider Details</td>
                <td class="expand-cell">
                  <div class="d-flex align-items-center justify-content-end">
                    <a
                      href="javascript: void(0)"
                      class="standart-link-action"
                      (click)="
                        remittance.isProviderExpanded =
                          !remittance.isProviderExpanded
                      "
                      [class.expanded]="remittance.isProviderExpanded"
                      [attr.aria-expanded]="!remittance.isProviderExpanded"
                    >
                      <i class="fas fa-chevron-down"></i>
                    </a>
                  </div>
                </td>
              </tr>

              <tr
                class="claim-remit-inner"
                *ngIf="remittance.isProviderExpanded"
              >
                <td>providerGroupId</td>
                <td>{{ remittance.providerGroupId || 'N/A' }}</td>
              </tr>
              <tr>
                <td>patientName</td>
                <td>{{ remittance.providerId || 'N/A' }}</td>
              </tr>
              <tr>
                <td>patientName</td>
                <td>{{ remittance.serviceProviderNPI || 'N/A' }}</td>
              </tr>

              <tr>
                <td>File Details</td>
                <td class="expand-cell">
                  <div class="d-flex align-items-center justify-content-end">
                    <a
                      href="javascript: void(0)"
                      class="standart-link-action"
                      (click)="
                        remittance.isFileExpanded = !remittance.isFileExpanded
                      "
                      [class.expanded]="remittance.isFileExpanded"
                      [attr.aria-expanded]="!remittance.isFileExpanded"
                    >
                      <i class="fas fa-chevron-down"></i>
                    </a>
                  </div>
                </td>
              </tr>

              <tr class="claim-remit-inner" *ngIf="remittance.isFileExpanded">
                <td>fileName</td>
                <td>{{ remittance.fileName || 'N/A' }}</td>
              </tr>
              <tr>
                <td>outputFilename</td>
                <td>{{ remittance.outputFilename || 'N/A' }}</td>
              </tr>
              <tr>
                <td>actualFilename</td>
                <td>{{ remittance.actualFilename || 'N/A' }}</td>
              </tr>
              <tr>
                <td>xmlFilename</td>
                <td>{{ remittance.xmlFilename || 'N/A' }}</td>
              </tr>
              <tr>
                <td>filename277ca</td>
                <td>{{ remittance.filename277ca || 'N/A' }}</td>
              </tr>
              <tr>
                <td>csvFilename</td>
                <td>{{ remittance.csvFilename || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>

    <div
      *ngSwitchDefault
      class="d-flex justify-content-center align-items-center h-100 text-center"
    >
      <empty-state
        [title]="
          panel
            ? claimPanelNames[panel] + ' Not Provided'
            : 'Select Panel Content'
        "
        size="sm"
      ></empty-state>
    </div>
  </ng-container>
</div>

<ng-template #error>
  <div
    class="d-flex justify-content-center align-items-center h-100 text-center"
  >
    <empty-state
      [title]="
        panel
          ? claimPanelNames[panel] + ' Not Provided'
          : 'Select Panel Content'
      "
      size="sm"
    ></empty-state>
  </div>
</ng-template>

<ng-template #loading>
  <div
    class="d-flex justify-content-center align-items-center h-100 text-center"
  >
    <loader></loader>
  </div>
</ng-template>
